import clsx from 'clsx'

export interface ErrorTextProps {
	id?: string
	message?: string
	className?: string
}

export function ErrorText({ id, message = '', className = '' }: Readonly<ErrorTextProps>) {
	return (
		<div id={id} className={clsx('text-secondary-red text-sm', className)}>
			{message}
		</div>
	)
}
